import { render, staticRenderFns } from "./LivestreamLeaderboard.vue?vue&type=template&id=1f530aa6&scoped=true"
import script from "./LivestreamLeaderboard.vue?vue&type=script&lang=js"
export * from "./LivestreamLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./LivestreamLeaderboard.vue?vue&type=style&index=0&id=1f530aa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f530aa6",
  null
  
)

export default component.exports